import { InstallmentActions } from "../actions";

const initialState = {
  rows: [],
  rowCount: 1,
  pageCount: 1,
};

export default function installment(state = initialState, action) {
  switch (action.type) {
    case InstallmentActions.ACTION_SAVE_INSTALLMENTS:
      return action.payload;
    default:
      return state;
  }
}

export function getInstallments(state) {
  return state.installment;
}
